import { appendReduxParts } from "infrastructure/store";

import CreateRelease from "./CreateRelease";
import { createReleaseSaga } from "./CreateRelease.saga";
import { createReleaseManager } from "./CreateRelease.slice";

export * from "./CreateRelease.slice";
export { CreateRelease };
appendReduxParts(
  [
    {
      reducerName: createReleaseManager.name,
      reducer: createReleaseManager.reducer
    }
  ],
  [createReleaseSaga()]
);
